/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DailyEntitySummaryUsageResponse { 
    /**
     * Timestamp in UTC when the interval was inserted in table
     */
    created_ts?: Date;
    entity_id?: string;
    /**
     * max rwr cb protected vm count on usage_date
     */
    max_rwr_cb_vm_count?: number;
    /**
     * max rwr cs protected vm count on usage_date
     */
    max_rwr_cs_vm_count?: number;
    /**
     * maximum Tibs used on usage_date
     */
    max_tibs_used?: number;
    /**
     * maximum VM count used on usage_date
     */
    max_vm_count?: number;
    /**
     * minimum Tibs used on usage_date
     */
    min_tibs_used?: number;
    /**
     * minimum VM count used on usage_date
     */
    min_vm_count?: number;
    org_id?: string;
    /**
     * data center name
     */
    tibs_geo_name?: string;
    /**
     * total un-extrapolated VM hours
     */
    tibs_usage_extrapolated_hours?: number;
    /**
     * total un-extrapolated Tibs hours
     */
    tibs_usage_hours?: number;
    /**
     * total Tibs used on usage_date
     */
    total_tibs_used?: number;
    /**
     * total VM count used on usage_date
     */
    total_vm_count?: number;
    /**
     * Timestamp in UTC when the interval was updated in table
     */
    updated_ts?: Date;
    /**
     * Aggregated date with YYYY-MM-DD format of the usage
     */
    usage_date?: string;
    /**
     * VCDS service type value.
     */
    vcds_service_type?: string;
    /**
     * total un-extrapolated VM hours
     */
    vm_usage_extrapolated_hours?: number;
    /**
     * total un-extrapolated VM hours
     */
    vm_usage_hours?: number;
}

